export default {
    namespaced: true,
    state() {
        return {
            showDepartures: false,
            showDisabledProperties: false,
            showOwnerBlocks: false,
            showSubscriberBlocks: false,
            showNotes: false,
            properties: [],
        };
    },
    getters: {
        showDepartures: state => state.showDepartures,
        showDisabledProperties: state => state.showDisabledProperties,
        showOwnerBlocks: state => state.showOwnerBlocks,
        showSubscriberBlocks: state => state.showSubscriberBlocks,
        showNotes: state => state.showNotes,
        properties: state => state.properties,
    },
    mutations: {
        setShowDepartures(state, showDepartures) {
            state.showDepartures = showDepartures;
        },
        setShowDisabledProperties(state, showDisabledProperties) {
            state.showDisabledProperties = showDisabledProperties;
        },
        setShowOwnerBlocks(state, showOwnerBlocks) {
            state.showOwnerBlocks = showOwnerBlocks;
        },
        setShowSubscriberBlocks(state, showSubscriberBlocks) {
            state.showSubscriberBlocks = showSubscriberBlocks;
        },
        setShowNotes(state, showNotes) {
            state.showNotes = showNotes;
        },
        setProperties(state, properties) {
            state.properties = properties;
        },
    },
    actions: {
        async changeShowDepartures({ commit }, value) {
            commit('setShowDepartures', value);
        },
        async changeShowDisabledProperties({ commit }, value) {
            commit('setShowDisabledProperties', value);
        },
        async changeShowOwnerBlocks({ commit }, value) {
            commit('setShowOwnerBlocks', value);
        },
        async changeShowSubscriberBlocks({ commit }, value) {
            commit('setShowSubscriberBlocks', value);
        },
        async changeShowNotes({ commit }, value) {
            commit('setShowNotes', value);
        },
        async changeProperties({ commit }, value) {
            commit('setProperties', value);
        },
    },
};
